interface IParams {
  isWebview: boolean;
  platform: string | null;
  defaultSource: string;
  cian_source?: string;
}

/**
 * Возвращает поле source для создания заявки
 * */
export const getMessageSource = ({ isWebview, platform, cian_source, defaultSource }: IParams): string => {
  const { referrer } = document;

  const source = cian_source ? `${defaultSource}_${cian_source}` : defaultSource;

  switch (true) {
    case isWebview:
      return platform ? `${source}_${platform}` : source;

    case referrer.includes('podbor-rieltora'):
      return `${defaultSource}-landing-page`;

    default:
      return source;
  }
};
